import React from 'react'
import PropTypes from 'prop-types'
import {useStaticQuery, graphql} from 'gatsby'
import {css} from '@emotion/react'
import {convertDatoCmsImgPathsToLocal} from '../util/datoCmsDataFactory'
import {colors, globalStylesProtection} from '../constants'
import Layout from '../components/layout'
import SEO from '../components/seo'
import HamburgerMenu from '../components/HamburgerMenu'
import Footer from '../components/templates/protection-v1/Footer'
import SurveyFeedback from '../components/SurveyFeedback'

import StartpageLogoRedesign from '../images/startpage-logo-redesign.svg'

const CONTAINER_STYLES = `
    width: 1200px;
    margin: auto;
    padding: 0 1rem;
`

const Feedback = ({languageCode}) => {
    const site = useStaticQuery(graphql`
        query FeedbackPage {
            site {
                siteMetadata {
                    ...Feedback
                }
            }
        }
    `)
    const {
        hamburgerLinks,
        feedbackSection1Image: {url: heroImageUrl = ``},
        feedbackSection1Title,
        feedbackSection1Description,
        feedbackSection2SurveyButtonText,
        feedbackSection2Title,
        feedbackSection2SurveyOptions,
        feedbackSection2SurveyCompleteTitle,
        footerBlogAsset,
        footerLinks,
    } = site.site.siteMetadata.privacyprotect[languageCode]

    const homeLink = `https://www.startpage.com/${languageCode}`

    return (
        <Layout globalStyles={globalStylesProtection}>
            <SEO title={feedbackSection1Title} description={feedbackSection2Title} />
            <section
                css={css`
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    color: ${colors.midnight};
                `}
            >
                <section
                    className="header"
                    css={css`
                        background: ${colors.whisper};
                    `}
                >
                    <div
                        css={css`
                            ${CONTAINER_STYLES}
                            padding: 3rem 1rem;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                        `}
                    >
                        <a href={homeLink} rel="noopener noreferrer">
                            <StartpageLogoRedesign />
                        </a>
                        <div
                            css={css`
                                display: flex;
                                align-items: center;
                            `}
                        >
                            <HamburgerMenu links={hamburgerLinks} />
                        </div>
                    </div>
                </section>

                <section
                    className="hero"
                    css={css`
                        background: ${colors.whisper};
                    `}
                >
                    <div
                        css={css`
                            ${CONTAINER_STYLES}
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            position: relative;
                            padding: 2rem 0 5rem;
                            h1 {
                                font-size: 38px;
                                font-weight: 600;
                                margin-bottom: 2rem;
                            }
                            h3 {
                                font-size: 16px;
                                font-weight: 400;
                                line-height: 22px;
                            }
                        `}
                    >
                        {/* these divs are like a confeti texture in the bg */}
                        <div
                            css={css`
                                height: 40px;
                                width: 40px;
                                background: ${colors.whisperDark};
                                position: absolute;
                                opacity: 0.5;
                                left: 42.5rem;
                                top: 9rem;
                            `}
                        />
                        <div
                            css={css`
                                height: 64px;
                                width: 64px;
                                border: 2.5px solid ${colors.brandBlueLight};
                                position: absolute;
                                left: 43.5rem;
                                top: 10rem;
                            `}
                        />
                        <div
                            css={css`
                                height: 64px;
                                width: 64px;
                                border: 2.5px solid ${colors.whisperDark};
                                position: absolute;
                                right: -2rem;
                                top: 4rem;
                            `}
                        />
                        <div
                            css={css`
                                display: flex;
                                flex-direction: column;
                                max-width: 450px;
                                margin-left: 1rem;
                            `}
                        >
                            <h1>{feedbackSection1Title}</h1>
                            <h3>{feedbackSection1Description}</h3>
                        </div>
                        <div
                            css={css`
                                flex: 0 0 50%;
                                img {
                                    position: absolute;
                                    top: 0;
                                    right: 1.5rem;
                                    margin-bottom: -1rem;
                                }
                            `}
                        >
                            <img src={convertDatoCmsImgPathsToLocal(heroImageUrl)} alt="key with computer" />
                        </div>
                    </div>
                </section>

                <section
                    className="survey"
                    css={css`
                        ${CONTAINER_STYLES}
                        padding: 3rem 1rem;
                        margin: 0 auto;
                    `}
                >
                    <SurveyFeedback
                        title={feedbackSection2Title}
                        surveyCompleteTitle={feedbackSection2SurveyCompleteTitle}
                        optionData={feedbackSection2SurveyOptions}
                        buttonText={feedbackSection2SurveyButtonText}
                    />
                </section>
                <Footer languageCode={languageCode} links={footerLinks} footerBlogAsset={footerBlogAsset} />
            </section>
        </Layout>
    )
}

Feedback.propTypes = {
    languageCode: PropTypes.string,
}

Feedback.defaultProps = {
    languageCode: `en`,
}

export default Feedback
